import React, {Component} from "react";
import {observer, inject} from "mobx-react";
import {Modal, Button} from "antd";

@inject("dialog")
@observer
class RewardDialog extends Component {
  handleOk = () => {
    this.props.dialog.setRewardOpen(false);
  };

  handleCancel = () => {
    this.props.dialog.setRewardOpen(false);
  };

  render() {
    return (
      <Modal
        title="赞赏"
        okText="确认"
        cancelText="取消"
        visible={this.props.dialog.isRewardOpen}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        footer={[
          <Button key="submit" type="primary" onClick={this.handleOk}>
            确认
          </Button>,
        ]}
        bodyStyle={{
          paddingTop: "20px",
          textAlign: "center",
        }}
        width={400}
      >
        <div style={style.container}>
          <p style={style.text}>丰俭由人，祝愿你日进斗金</p>
          <img
            src="/zhanshangma.jpg"
            alt="赞赏码"
            style={style.image}
          />
          <p style={style.footer}>wangshiyu 的赞赏码</p>
        </div>
      </Modal>
    );
  }
}

const style = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  text: {
    marginBottom: "20px",
    fontSize: "16px",
    color: "#333",
    fontWeight: "500",
  },
  image: {
    maxWidth: "100%",
    height: "auto",
    marginBottom: "15px",
    borderRadius: "8px",
  },
  footer: {
    marginTop: "10px",
    fontSize: "14px",
    color: "#666",
  },
};

export default RewardDialog;

